import axios from "axios";
import Config from "./Config";

const BASE_URL = Config.HOST;

const requestStatus = {};
const specificUrls = [
  "/api/conversation",
  "/api/message/getProfileInfo",
  "/api/message/groupInfoV2",
  "/api/conversation/groupMember",
  "/api/message/filter",
  "/api/message/filterMedia",
  "/api/message/filterFile",
  "/api/message/filterLink",
  "/api/conversation/pinMsgList",
  "/api/message/onlineStatus",
];

let token = localStorage.getItem("userToken");

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: `Bearer ` + token
  }
});

const getUrlSpecific = (url, data) => {
  if (url !== "/api/message/filter") return url
  if (!data.msgTypes || !data.msgTypes.length) return url
  if (data.msgTypes.includes('chat.photo')) {
    return "/api/message/filterMedia"
  } else if (data.msgTypes.includes('share.file')) {
    return "/api/message/filterFile"
  } else if (data.msgTypes.includes('chat.link')) {
    return "/api/message/filterLink"
  }
}

instance.interceptors.request.use(
  config => {
    // Remove old request
    const url = getUrlSpecific(config.url, config.data)
    if (specificUrls.includes(url)) {
      if (requestStatus[url] && requestStatus[url].isExecuting) {
        requestStatus[url].cancel('Operation canceled by the user.');
      }
      requestStatus[url] = {
        isExecuting: true,
        cancel: null,
      };
      config.cancelToken = new axios.CancelToken(function (cancel) {
        requestStatus[url].cancel = cancel;
      });
    }

    let expTime = localStorage.getItem("userTokenExpTime");
    if (expTime && new Date(new Date(expTime).getTime() - 60 * 60 * 1000) < new Date().getTime() && config.url !== '/api/auth/verify') {
      document.dispatchEvent(new Event('Reverify'))
    }

    let userToken = localStorage.getItem("userToken");
    config.headers.Authorization = `Bearer ` + userToken;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const url = getUrlSpecific(response.config.url, response.config.data)
    if (specificUrls.includes(url)) {
      requestStatus[url].isExecuting = false;
    }
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.code === 'ERR_CANCELED') {
      return {
        data: null,
        status: 500,
        message: 'ERR_CANCELED',
      };
    }
    const url = getUrlSpecific(error.config?.url, error.config?.data)
    if (specificUrls.includes(url)) {
      requestStatus[url].isExecuting = false;
    }
    return Promise.reject(error.response?.data);
  }
);

export var HTTP = instance;
